// frontend/src/components/ChatWindow.tsx
import React, { useCallback, useState } from 'react';
import { useChat } from '../hooks/useChat';
import { useToolCallProcessor } from '../hooks/useToolCallProcessor';
import { printServiceRequest } from '../utils/printingUtils';
import { ServiceRequestArgs } from '../types/chatTypes';

import { MessageList } from './MessageList';
import { ChatInput } from './ChatInput';

import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import { XLg } from 'react-bootstrap-icons'; // Icono para cerrar

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

// --- AÑADIR PROP handleClose ---
interface ChatWindowProps {
    handleClose: () => void;
}

export function ChatWindow({ handleClose }: ChatWindowProps) {
    const {
        history, isLoading, error, sendMessage,
        latestToolCallRequest, clearToolRequest,
        sendToolResult
    } = useChat(API_BASE_URL);

    const [pendingPrintData, setPendingPrintData] = useState<ServiceRequestArgs | null>(null);

    const handleServiceRequestPrint = useCallback((serviceData: ServiceRequestArgs) => {
        setPendingPrintData(serviceData);
        return true;
    }, []);

    const handleUserPrintClick = () => {
        if (pendingPrintData) {
            printServiceRequest(pendingPrintData);
            setPendingPrintData(null);
        }
    };

    useToolCallProcessor({
        latestToolCallRequest,
        isLoading,
        sendToolResult,
        clearToolRequest,
        handleServiceRequestPrint,
    });

    const errorDisplay = error && <div className="alert alert-danger p-2 mb-2 mx-2">Error: {error}</div>;

    const pendingPrintDisplay = pendingPrintData && (
        <div className="alert alert-info mx-2 mb-2 p-2">
            <div>¿Deseas imprimir la solicitud de servicio como PDF?</div>
            <Button variant="primary" size="sm" className="mt-2" onClick={handleUserPrintClick}>
                Imprimir PDF
            </Button>
        </div>
    );

    const chatInputDisplay = <ChatInput onSendMessage={sendMessage} isLoading={isLoading} />;

    // --- CONTENEDOR FLOTANTE CON BOTÓN DE CERRAR ---
    return (
      <div className="chat-window-popup">
        {/* Layout Desktop */}
        <Card className="d-none d-md-flex flex-column chat-card-desktop-popup">
            <Card.Header as="h5" className="d-flex justify-content-between align-items-center">
                JIT IA
                <Button variant="light" size="sm" onClick={handleClose} aria-label="Cerrar chat">
                    <XLg />
                </Button>
            </Card.Header>
            <Card.Body className="d-flex flex-column overflow-hidden p-2">
                {errorDisplay}
                <div className="message-list-container" style={{ flexGrow: 1, overflowY: 'auto', marginBottom: '0.5rem' }}>
                    <MessageList history={history} isLoading={isLoading} />
                </div>
                {pendingPrintDisplay}
            </Card.Body>
            <Card.Footer style={{ background: 'white', padding: '0.5rem 1rem' }}>
                {chatInputDisplay}
            </Card.Footer>
        </Card>

        {/* Layout Mobile */}
        <div className="d-flex flex-column d-md-none chat-mobile-layout-popup">
            <div className="bg-light p-2 text-center border-bottom d-flex justify-content-between align-items-center">
                <h5 className="mb-0 fs-6">JIT IA</h5>
                <Button variant="light" size="sm" onClick={handleClose} aria-label="Cerrar chat">
                    <XLg />
                </Button>
            </div>
            <div className="flex-grow-1 d-flex flex-column overflow-hidden p-2">
                {errorDisplay}
                <div className="message-list-container" style={{ flexGrow: 1, overflowY: 'auto', marginBottom: '0.5rem' }}>
                    <MessageList history={history} isLoading={isLoading} />
                </div>
                {pendingPrintDisplay}
            </div>
            <div className="chat-mobile-footer p-2 border-top bg-white">
                {chatInputDisplay}
            </div>
        </div>
      </div>
    );
}